import { render, staticRenderFns } from "./ORTOptimizationComparisonChart.vue?vue&type=template&id=13379c69&scoped=true"
import script from "./ORTOptimizationComparisonChart.vue?vue&type=script&lang=js"
export * from "./ORTOptimizationComparisonChart.vue?vue&type=script&lang=js"
import style0 from "./ORTOptimizationComparisonChart.vue?vue&type=style&index=0&id=13379c69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13379c69",
  null
  
)

export default component.exports